import { Outlet } from 'react-router-dom';

const DevicePage = () => {
  return <Outlet />;
};

export default DevicePage;
